export const SocialMediaPlatforms = {
  FACEBOOK: 'Facebook',
  YOUTUBE: 'YouTube',
  INSTAGRAM: 'Instagram',
  TIKTOK: 'TikTok',
  WECHAT: 'WeChat',
  MESSENGER: 'Messenger',
  TELEGRAM: 'Telegram',
  VIBER: 'Viber',
  SNAPCHAT: 'Snapchat',
  X: 'X (Twitter)',
  PINTEREST: 'Pinterest',
  REDDIT: 'Reddit',
  LINKEDIN: 'LinkedIn',
  QUORA: 'Quora',
  DISCORD: 'Discord',
  THREADS: 'Threads',
  TWITCH: 'Twitch',
  TUMBLR: 'Tumblr',
} as const;

export const socialMediaFormFields = [
  {
    type: 'select',
    name: 'platform',
    label: 'Social Media',
    grid: {
      md: 3,
    },
    items: [
      ...Object.entries(SocialMediaPlatforms).map(([value, label]) => ({
        label,
        value,
      })),
    ],
  },
  {
    type: 'input',
    grid: {
      md: 3,
    },
    name: 'username',
    label: 'Username',
  },
];
